import { render, staticRenderFns } from "./OrderCardDesktop.vue?vue&type=template&id=36f3165e&"
import script from "./OrderCardDesktop.vue?vue&type=script&lang=ts&"
export * from "./OrderCardDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCardDesktop.vue?vue&type=style&index=0&id=36f3165e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports